import { useEffect, useRef } from 'react';
import { APP_PAGES } from '@tajawal/web-core-sdk-v2/lib/constants';
import { pushFlightResultCardViewdEvent, pushStepFlightCardViewdEvent } from '@/utils/avoGtm.utils';

export default function usePushCardView({
  itinerary,
  groupInfo,
  isGroup,
  isInView,
  currentPage,
  $resources,
  isSeatsRemainingReady,
}) {
  const isViewdOnce = useRef(false);

  useEffect(() => {
    const shouldPush = isInView && currentPage === APP_PAGES.FLIGHTS_RESULTS && $resources && isSeatsRemainingReady;
    if (shouldPush) {
      pushFlightResultCardViewdEvent({
        isGroup,
        itinerary,
        index: groupInfo?.index,
        $resources,
      });
      const {
        searchRequest: { isRoundTrip },
      } = itinerary || {};
      if (isRoundTrip) {
        pushStepFlightCardViewdEvent({
          isGroup,
          itinerary,
          index: groupInfo?.index,
          $resources,
        });
      }
      isViewdOnce.current = true;
    }
  }, [isInView, isGroup, $resources, isSeatsRemainingReady]);
}
